var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcMsgCarousel(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icMsgCarousel") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.9551445,45.4 C21.8844253,45.4 21.812867,45.382628 21.7483806,45.3480031 C21.6069421,45.2725659 21.5188427,45.1253801 21.5188427,44.9667717 L21.5188427,38.7949639 C17.6988039,36.8231267 15.6,33.3707457 15.6,29.0451259 C15.6,22.3603692 21.7902128,17.32 30,17.32 C38.2097872,17.32 44.4,22.3603692 44.4,29.0451259 C44.4,35.7289307 38.2097872,40.7692999 30,40.7692999 C29.7303079,40.7692999 29.4658898,40.7546646 29.2006326,40.7407432 L29.1831326,40.7399103 L22.1951106,45.3280134 C22.1227132,45.3757268 22.0389289,45.4 21.9551445,45.4 Z M24.125,30.9166667 C24.9074034,30.9166667 25.5416667,30.2824034 25.5416667,29.5 C25.5416667,28.7175966 24.9074034,28.0833333 24.125,28.0833333 C23.3425966,28.0833333 22.7083333,28.7175966 22.7083333,29.5 C22.7083333,30.2824034 23.3425966,30.9166667 24.125,30.9166667 Z M30.5,30.9166667 C31.2824034,30.9166667 31.9166667,30.2824034 31.9166667,29.5 C31.9166667,28.7175966 31.2824034,28.0833333 30.5,28.0833333 C29.7175966,28.0833333 29.0833333,28.7175966 29.0833333,29.5 C29.0833333,30.2824034 29.7175966,30.9166667 30.5,30.9166667 Z M36.875,30.9166667 C37.6574034,30.9166667 38.2916667,30.2824034 38.2916667,29.5 C38.2916667,28.7175966 37.6574034,28.0833333 36.875,28.0833333 C36.0925966,28.0833333 35.4583333,28.7175966 35.4583333,29.5 C35.4583333,30.2824034 36.0925966,30.9166667 36.875,30.9166667 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icMsgCarousel"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30,0 C13.5002729,0 0,13.5002729 0,30 C0,46.4997271 13.5002729,60 30,60 C46.4997271,60 60,46.4997271 60,30 C60,13.5002729 46.4997271,0 30,0 Z",
    id: "Stroke-1",
    fill: "#7BCB45",
    transform: "translate(30.000000, 30.000000) rotate(-360.000000) translate(-30.000000, -30.000000) "
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMsgCarousel);
export default __webpack_public_path__ + "static/media/icMsgCarousel.4a452acad68450f29c0156996588032b.svg";
export { ForwardRef as ReactComponent };